<template>
    <div>
        <v-card >
            <v-card-title class="blue-grey white--text">
                <v-row>
                    <v-col cols="6" md="6">VENTA</v-col>
                    <v-col cols="6" md="6" class="text-end">
                        <h5 class="text-caption white--text">Bodega: {{ txtSucursal }}</h5>
                        <h5 class="text-caption white--text">Dirección Tributaria: {{ txtOffice }}</h5>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="8" md="2">
                                <v-text-field class='text-caption' v-model="orden" label="Numero Cotiza" :disabled="disabledOrden" :filled="filledOrden" outlined dense required></v-text-field>
                            </v-col>
                            <v-col cols="4" md="1">
                                <v-btn @click="verOrden(orden)" class="mt-1" small color="teal" dark rounded><v-icon small>search</v-icon></v-btn>
                            </v-col>
                            <v-col cols="8" md="2">
                                <v-text-field class='text-caption' v-model="rut" label="Rut Cliente" dense outlined filled disabled></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field class='text-caption' v-model="razon" label="Nombre" dense outlined filled disabled></v-text-field>
                            </v-col>
                        </v-row>
                        <v-divider style="width:0px"></v-divider>
                        <v-row>
                            <v-col cols="12" md="9">
                                <v-data-table :headers="headers" :items="items" :page.sync="page" :items-per-page="itemsPerPage" hide-default-footer class="elevation-1 text-size col-color" @page-count="pageCount = $event">
                                    <template v-slot:item.stock="{ item }">
                                        <v-icon v-if="item.stock=='si'" small class="text green--text">check</v-icon>
                                        <v-icon v-if="item.stock=='no'" small class="text red--text">clear</v-icon>
                                    </template>
                                </v-data-table>
                                <v-pagination v-model="page" :length="pageCount"></v-pagination>
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-alert class='text-caption' dense text border="left" color="grey">
                                    <div class="float-left">
                                        Neto
                                    </div>
                                    <div class="float-right">
                                        ${{new Intl.NumberFormat("de-DE").format(parseFloat(neto))}}
                                    </div>                                             
                                </v-alert>
                                <v-alert class='mt-n2 text-caption' dense text border="left" color="grey">
                                    <div class="float-left">
                                        Iva ({{impuesto}}%)
                                    </div>
                                    <div class="float-right">
                                        ${{new Intl.NumberFormat("de-DE").format(parseFloat(iva))}}
                                    </div>                                             
                                </v-alert>
                                <!-- <v-alert class='mt-n2 text-caption' dense text border="left" color="grey">
                                    <div class="float-left">
                                        Ajuste
                                    </div>
                                    <div class="float-right">
                                        ${{new Intl.NumberFormat("de-DE").format(parseFloat(ajuste))}}
                                    </div>                                             
                                </v-alert> -->
                                <v-alert style="height:40px;" class='mt-n2 text-body-2' dense text border="left" color="red">
                                    <div class="mt-1 float-left">
                                        Total
                                    </div>
                                    <div class="mt-1 float-right">
                                        ${{new Intl.NumberFormat("de-DE").format(parseFloat(total))}}
                                    </div>                                             
                                </v-alert>
                                <!-- <v-alert class='text-caption' dense text border="left" color="grey">Neto ($):{{neto.toLocaleString()}}</v-alert> 
                                <v-alert class='text-caption' dense text border="left" color="grey">Iva ({{impuesto}}%): {{iva}}</v-alert>
                                <v-alert class='text-caption' dense text border="left" color="grey">Ajuste ({{impuesto}}%): {{iva}}</v-alert>
                                <v-alert class='text-caption' dense text border="left" color="red">Total ($): {{total.toLocaleString()}}</v-alert> -->
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="2">
                                <v-select class='text-caption' v-model="dte" :items="itemDTE" label="Tipo Documento" item-text="doc" item-value="id"></v-select>
                            </v-col>
                            <v-col cols="12" md="2">
                                <v-select class='ml-2 text-caption' v-model="pago" :items="itemPAGO" label="Forma Pago" item-text="forma" item-value="id"></v-select>
                            </v-col>
                            <v-col cols="12" md="2">
                                <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field class="mt-3" v-model="vencimiento" label="Vencimiento" prepend-icon="event" readonly v-bind="attrs" v-on="on" dense outlined></v-text-field>
                                    </template>
                                    <v-date-picker v-model="vencimiento" @input="menu1 = false"></v-date-picker>
                                </v-menu>
                            </v-col>
                             <v-col cols="12" md="3">
                                <v-text-field class='text-caption' v-model="envio" label="Envio Digital" dense filled></v-text-field>
                            </v-col>
                            <v-col cols="12" md="3">
                                <div class="mt-5 text-right">
                                    <v-btn @click="newVenta()" small color="teal" dark rounded><v-icon small>add_circle</v-icon><span class='text-btn'>Nuevo</span></v-btn>
                                    <!-- <v-btn v-if="btnGrabar===true" @click="outDTE(dte,pago)" class="ml-2" small color="teal" dark rounded><v-icon small>save</v-icon><span class='text-btn'>Grabar</span></v-btn> -->
                                    <v-btn v-if="btnGrabar===true" @click="enviarDTE(dte,pago)" class="ml-2" small color="teal" dark rounded><v-icon small>save</v-icon><span class='text-btn'>Enviar DTE</span></v-btn>
                                    <v-btn v-else class="ml-2" small color="grey" dark rounded><v-icon small>save</v-icon><span class='text-btn'>Enviar DTE</span></v-btn>
                                    <a  v-if="btnPrt===true" target="_blank" :href="html" class="ml-2"><v-icon color="teal">print</v-icon></a>
                                    <a  v-else href="javascript:void(0)" class="ml-3"><v-icon class="grey--text">print</v-icon></a>
                                    <!-- <a  class="ml-2" v-if="descargaCSV===false" href="javascript:void(0)" @click="fileCSV()"><img valign="middle" src="@/assets/csv.png" width="16px" height="20px"/></a>
                                    <a  class="ml-2" v-else :href="rutaCSV"><v-icon color="teal">cloud_download</v-icon></a> -->
                                </div>
                            </v-col>
                        </v-row>
                    </v-container>
            </v-card-text>
            <v-card-actions style="margin-top:-35px">
            </v-card-actions>
        </v-card>
        <snack :Msg="Msg" :color="color" :msgbox="msgbox"/>
        <dialogo :loading="loading"  />        
    </div>
</template>
<style scoped>
.text-size >>> td {
    font-size: 9pt !important;
    height: 25px !important;
    /*background-color: lightyellow;*/ 
}
.col-color >>> th {
    background-color: lightgrey;
}
</style>
<script>
import snack from '@/components/snack.vue';
import dialogo from '@/components/dialogo.vue';
import axios from 'axios';
export default {
    name:'Venta', 
    components:{dialogo, snack},
    props: ['usu','contrato'],   
    data(){
        return{
            //contrato:'123',
            loading:false,
            msgbox:false,
            color:'',
            Msg:'',
            disabledOrden:false,
            filledOrden:false,
            btnGrabar:false,
            btnPrt:false,
            html:'',
            orden:'',
            entidad:'',
            rut:'',
            razon:'',
            direccion:'',
            comuna:'',
            ciudad:'',
            giro:'',
            fecha:'',
            hoy:'',
            neto:0,
            impuesto:'',
            iva:0,
            ajuste:0,
            total:0,
            dte:'',
            pago:'',
            page: 1,
            pageCount: 0,
            itemsPerPage: 4,
            headers: [
                { text: 'Codigo', align: 'start', sortable: true, value: 'codigo' },
                { text: 'Producto', align: 'start', sortable: false, value: 'producto' },
               // { text: 'Neto', align: 'center', sortable: false, value: 'neto' },
                { text: 'Precio', align: 'center', sortable: false, value: 'precio' },
                { text: 'cantidad', align: 'center', sortable: false, value: 'cantidad' },
                { text: 'Stock', align: 'center', sortable: false, value: 'stock' },
            ],
            items: [],
            itemDTE:[
                {id:'22',doc:'Boleta'},
                {id:'5',doc:'Factura'},
            ],
            itemPAGO:[],
            OutID:0,
            descargaCSV:false,
            rutaCSV:'',   
            envio:'',
            nStock:0,
            txtStock:'si',
            nSucursal:0,
            txtSucursal:'',
            menu1:false,
            vencimiento:(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            idLocal:0,
            office:1,
            itemsucursal:[],
            txtOffice:'',
        }
    },
    async mounted(){
        await this.buscaSucursal();
        await this.buscaLocal();
        await this.newVenta();
        await this.cargaPagos('1-9');
    },
    methods:{
        async buscaSucursal(){
            const response = await axios.get(process.env.VUE_APP_URL + '/public/api/inv/sucursales/'+this.contrato);
            const datos=response.data;
            this.itemsucursal=[];
            if (datos[0].existe=='si'){
                datos.forEach(element => {
                    this.itemsucursal.push({"code":element.Oficina,"name":element.Nombre})
                });
            }
        },
        async buscaLocal(){
            try {
                const response = await axios.get(process.env.VUE_APP_URL + '/public/api/inv/usuarios/'+this.contrato+'/'+this.usu);
                const datos=response.data;
                if (datos[0].existe=='si'){
                    this.idLocal=datos[0].Bodega;
                    this.nSucursal=this.idLocal;
                    this.office = datos[0].Sucursal;
                    const sucu=await this.buscarSucursal_v2();
                    this.txtOffice='';
                    const filter = this.itemsucursal.filter(res => parseInt(res.code) == parseInt(this.office));
                    if(filter.length!=0){ this.txtOffice = filter[0].name};
                    if(sucu!=''){
                        this.txtSucursal=sucu;
                    } else {
                        this.txtSucursal=this.nSucursal;
                    }
                }
            } catch (error) {
                console.log(error)
            }
        },
        async cargaPagos(xRut){
            try {
                var auth='NO';
                const res = await axios.get(process.env.VUE_APP_URL + '/public/api/inv/clientes/'+this.contrato+'/'+ xRut);
                const dat=res.data;
                if (dat[0].existe=='si'){ auth=dat[0].Credito };            
                const response = await axios.get(process.env.VUE_APP_URL + '/public/api/inv/DTE/forma/pago/'+this.contrato);
                const datos=response.data;
                if (datos[0].existe=='si'){
                    this.itemPAGO=[];
                    datos.forEach(element => {
                        if(element.CodigoBsale=='4'){
                            if(auth=='SI'){
                                this.itemPAGO.push({
                                    'id':element.CodigoBsale,
                                    'forma':element.Descripcion
                                })
                            }
                        } else {
                            this.itemPAGO.push({
                                'id':element.CodigoBsale,
                                'forma':element.Descripcion
                            })
                        }
                    });
                }                
            } catch (error) {
                console.log(error)
            }
        },
        // async cargaPagos(){
        //     const response = await axios.get(process.env.VUE_APP_URL + '/public/api/inv/DTE/forma/pago/'+this.contrato);
        //     const datos=response.data;
        //     if (datos[0].existe=='si'){
        //         this.itemPAGO=[];
        //         datos.forEach(element => {
        //             this.itemPAGO.push({
        //                 'id':element.CodigoBsale,
        //                 'forma':element.Descripcion
        //             })
        //         });
        //     }
        // },
        async buscarSucursal_v2(){
            let res = '';
            try {
                const response = await axios.get(process.env.VUE_APP_URL + '/public/api/inv/bodegas/'+this.contrato);
                const datos=response.data;
                if (datos[0].existe=='si'){
                    datos.forEach(element => {
                        if(element.ID==this.nSucursal){
                            res = element.Nombre
                        };
                    });
                }                
            } catch (error) {
                console.log(error)
            };
            return res
        },
        // async buscarSucursal(){
        //     const response = await axios.get(process.env.VUE_APP_URL + '/public/api/inv/usuarios/'+this.contrato+'/'+this.usu);
        //     const datos=response.data;
        //     if (datos[0].existe=='si'){
        //         if (datos[0].Sucursal!=0){
        //             this.nSucursal=datos[0].Sucursal;
        //             const response1 = await axios.get(process.env.VUE_APP_URL + '/public/api/inv/sucursales/'+this.contrato);
        //             const datos1=response1.data;
        //             if (datos1[0].existe=='si'){
        //                 datos1.forEach(element => {
        //                     if(element.ID==this.nSucursal){
        //                         this.txtSucursal=element.Nombre                            
        //                     }
        //                 });
        //             } else {  
        //                 this.txtSucursal='Sin Sucursal';
        //                 this.nSucursal=0;
        //             }
        //         } else {
        //             this.txtSucursal='Sin Sucursal';
        //             this.nSucursal=0;
        //         }
        //     } else { 
        //         this.txtSucursal='Sin Sucursal';
        //         this.nSucursal=0;
        //     }
        // },
        async fileCSV(){
            if (this.btnPrt===true){
                this.loading=true;
                const response = await axios.get(process.env.VUE_APP_URL + '/public/api/inv/fileCsv/venta/'+this.contrato+'/'+this.OutID+'/'+this.entidad);
                const datos=response.data;
                //console.log(datos);
                if (datos=='si'){
                    this.descargaCSV=true;
                    this.rutaCSV=process.env.VUE_APP_URL + '/public/buzon/'+this.contrato+'/'+this.OutID+'.csv';
                }
                this.loading=false;
            }
        },
        showSnack(){
            setTimeout(()=>{this.msgbox=false},3000)
        },
        clsInput(){
            this.rut='';
            this.razon='';
            this.direccion='';
            this.comuna='';
            this.ciudad='';
            this.giro='';
            this.fecha='';
            this.hoy='';
            this.neto=0;
            this.iva=0;
            this.ajuste=0;
            this.total=0;
            this.impuesto='';
            this.dte='';
            this.pago='';
            this.items=[];
            this.btnPrt=false;
            this.html='';
            this.OutID=0;
            this.entidad='';
            this.descargaCSV=false;
            this.rutaCSV='';
            this.envio='';   
            this.nStock=0;
            this.txtStock='si';
        },
        newVenta(){
            this.orden='';
            this.disabledOrden=false;
            this.filledOrden=false;
            this.btnGrabar=false;
            this.clsInput()
        },
        async verOrden(nOrden){
            this.clsInput();
            this.loading=true;
            const response = await axios.get(process.env.VUE_APP_URL + '/public/api/inv/orden/'+this.contrato+'/'+nOrden);
            const datos=response.data;
            if (datos[0].existe=='si'){ 
                this.disabledOrden=true;
                this.filledOrden=true;
                this.btnGrabar=true;
                this.entidad=datos[0].Entidad;
                this.rut=datos[0].Rut;
                this.razon=datos[0].Nombre;
                this.direccion=datos[0].Direccion;
                this.comuna=datos[0].Comuna;
                this.ciudad=datos[0].Ciudad;
                this.giro=datos[0].Observacion;
                this.fecha=datos[0].Fecha;
                this.hoy=datos[0].Hoy;
                this.impuesto=datos[0].Iva;
                await this.cargaPagos(this.rut);
                this.items=[];
                let nNeto=0;
                let nTotal=0;
                for (let index = 0; index < datos.length; index++) {
                    const element = datos[index];
                    //calcular el neto del precio
                     let imp=1+(this.impuesto/100);
                     let unidad=element.Precio/imp;
                     //console.log(unidad);
                    //this.nStock=await this.totalStock(element.Bodega,element.Sku);
                    this.nStock=await this.totalStock(this.idLocal,element.Sku);
                    if (parseInt(this.nStock)>=parseInt(element.Cantidad)){
                        this.items.push({
                            'codigo':element.Sku,
                            'producto':element.Producto,
                            'precio':new Intl.NumberFormat("de-DE").format(parseFloat(element.Precio)),
                            'unitario':element.Precio,
                            'cantidad':element.Cantidad,
                            'neto':unidad,
                            //'bodega':element.Bodega,
                            'bodega':this.idLocal,
                            'stock':'si'
                        });
                    } else {
                        this.txtStock="no";
                        this.items.push({
                            'codigo':element.Sku,
                            'producto':element.Producto,
                            'precio':new Intl.NumberFormat("de-DE").format(parseFloat(element.Precio)),
                            'unitario':element.Precio,
                            'cantidad':element.Cantidad,
                            'neto':unidad,
                            //'bodega':element.Bodega,
                            'bodega':this.idLocal,
                            'stock':'no'
                        });
                    }
                    nNeto=nNeto+(unidad*parseInt(element.Cantidad));
                    nTotal=nTotal+parseInt(element.Total)
                };
                // datos.forEach(element => {
                //     this.items.push({
                //         'codigo':element.Sku,
                //         'producto':element.Producto,
                //         'precio':new Intl.NumberFormat("de-DE").format(parseFloat(element.Precio)),
                //         'unitario':element.Precio,
                //         'cantidad':element.Cantidad,
                //         'bodega':element.Bodega
                //     });
                //     nTotal=nTotal+parseInt(element.Total)       
                // });
                let nIva=(nNeto*parseInt(datos[0].Iva))/100;
                let nAjuste=nTotal-(nNeto+nIva);
                //nTotal=nTotal+nIva;
                this.neto=parseFloat(nNeto).toFixed(2);
                this.iva=parseFloat(nIva).toFixed(2);
                this.ajuste=parseFloat(nAjuste).toFixed(2);
                this.total=nTotal;
            } else {
                this.Msg='Orden no Existe o con DTE'
                this.msgbox=true;
                this.color='red';
                this.showSnack();
            }
            this.loading=false;
        },
        async totalStock(b,s){
            const response = await axios.get(process.env.VUE_APP_URL + '/public/api/inv/stock/bodegas/producto/total/'+ this.contrato +'/'+ b + '/' + s);
            const datos=response.data;
            if (datos[0].existe=='si'){ 
                 return datos[0].Total;
            } else { return 0 }
        },
        async enviarDTE(selectDTE,selectPago){
            // validar tipo de sistema
            var sigla=this.contrato.substring(0,3);
            //console.log(sigla);
            if (sigla=='INV') {
                await this.inDTE(selectDTE,selectPago);
            } else {
                if (sigla=='NDV'){
                    await this.outDTE(selectDTE,selectPago);
                } else {
                    this.Msg='Error de Contrato'
                    this.msgbox=true;
                    this.color='red';
                    this.showSnack();
                }
            }
        },
        async outDTE(selectDTE,selectPago){
            if (parseInt(this.total)!=0){
                if (selectDTE!=0 && selectPago!=0){
                    if(this.txtStock!="si"){
                        this.Msg='Productos sin Stock';
                        this.msgbox=true;
                        this.color='red';
                        this.showSnack();
                    } else {
                        this.loading=true;
                        this.btnGrabar=false;
                        this.OutID=0;
                        //obtener ID nuevo del dte
                        const params={
                            'contrato':this.contrato,
                            'orden':this.orden,
                            'estado':'V',
                            'usuario':this.usu
                        };
                        try {
                            const response = await axios.post(process.env.VUE_APP_URL + '/public/api/inv/DTE/id/new/v2/',params);
                            const res = response.data;
                            if (res=='si'){
                                const response1 = await axios.get(process.env.VUE_APP_URL + '/public/api/inv/DTE/id/new/v2/'+this.contrato+'/'+this.orden+'/'+this.usu);
                                const res1 = response1.data;
                                if (res1[0].existe=='si'){
                                    this.OutID=parseInt(res1[0].Folio); 
                                }                            
                            };
                            if (this.OutID!=0){
                                //console.log(this.OutID);
                                //confirmar que no existe en DTE
                                const response2 = await axios.get(process.env.VUE_APP_URL + '/public/api/inv/DTE/one/'+this.contrato+'/'+this.OutID);
                                const res2 = response2.data;
                                if (res2[0].existe=='no'){ 
                                    this.html=process.env.VUE_APP_URL + '/public/api/inv/prt/venta/v4/'+this.contrato+'/'+this.OutID+'/'+this.entidad;
                                    const paramsDTE={
                                        'contrato':this.contrato,
                                        'numero':this.OutID,
                                        'tipoDte':selectDTE,
                                        'tipoPago':selectPago,
                                        'neto':this.neto,
                                        'iva':this.iva,
                                        'total':this.total,
                                        'fecha':this.hoy,
                                        'vencimiento':this.vencimiento,
                                        'orden':this.orden,
                                        'rutaPDF':this.html,
                                        'rutaXML':this.html,
                                        'usuario':this.usu,
                                        'sucursal':this.nSucursal,
                                        'oficina':this.office,
                                    };     
                                    await this.saveDTE(paramsDTE);
                                } else {
                                    this.Msg='No Existen Folios'
                                    this.msgbox=true;
                                    this.color='red';
                                    this.showSnack();
                                }
                            } else {
                                this.Msg='Folio No Asignado'
                                this.msgbox=true;
                                this.color='red';
                                this.showSnack();
                            }
                        } catch (error) {
                            console.log(error)
                        }
                    }
                } else {
                    this.Msg='Seleccione DTE y Pago'
                    this.msgbox=true;
                    this.color='red';
                    this.showSnack();
                }
            } else {
                this.Msg='Sin Productos'
                this.msgbox=true;
                this.color='red';
                this.showSnack();
            }
            this.loading=false;
        },
        async inDTE(selectDTE,selectPago){
            if(this.nSucursal!=0){
                if(this.txtStock!="si"){
                    this.Msg='Productos sin Stock';
                    this.msgbox=true;
                    this.color='red';
                    this.showSnack();
                } else {
                    this.loading=true;
                    if (selectDTE!=0 && selectPago!=0){                
                        // obtenemos el token del contrato
                        let valToken='';
                        const resToken = await axios.get(process.env.VUE_APP_URL + '/public/api/inv/token/access/'+this.contrato);
                        const respuesta = resToken.data;
                        if (respuesta[0].existe=='si'){ 
                            valToken=respuesta[0].Token;
                        } else { console.log('Token Invalido') }
                        // fecha cotizacion formato Bsale
                        let intFecha=Date.parse(this.fecha);
                        let strFecha=intFecha.toString();
                        strFecha=strFecha.substring(0,10);
                        const numFecha=parseInt(strFecha);
                        // fecha actual formato Bsale
                        let intHoy=Date.parse(this.hoy);
                        let strHoy=intHoy.toString();
                        strHoy=strHoy.substring(0,10);
                        const numHoy=parseInt(strHoy);
                        // fecha vencimiento formato Bsale
                        let intVence=Date.parse(this.vencimiento);
                        let strVence=intVence.toString();
                        strVence=strVence.substring(0,10);
                        const numVence=parseInt(strVence);
                        // creamos json Bsale
                        let pCliente={
                            "code": this.rut,
                            "city": this.ciudad,
                            "company": this.razon,
                            "municipality": this.comuna,
                            "activity": this.giro,
                            "address": this.direccion
                        };
                        let pDetalle=[];
                        this.items.forEach(element => {
                            pDetalle.push({
                                //"variantId":1,
                                "netUnitValue":parseFloat(element.neto).toFixed(4),
                                "quantity": parseInt(element.cantidad),
                                //"taxId": "[1,2]",
                                "comment": element.producto,
                                //"discount": 0,
                                "taxes": [
                                    {
                                    "code": 14,
                                    "percentage": 19
                                    }
                                ]
                            })        
                        });
                        let pPago=[
                            {
                                "paymentTypeId": selectPago,
                                "amount": this.total,
                                "recordDate": numHoy
                            }
                        ];
                        let pReferencia=[
                            {
                                "number": this.orden,
                                "referenceDate": numFecha,
                                "reason": "Orden de Compra "+this.orden,
                                "codeSii": 801
                            }
                        ];
                        //console.log(selectDTE);
                        var emitDTE;
                        if(selectDTE!=22){ // factura
                            emitDTE=
                            {
                                "documentTypeId": selectDTE,
                                "officeId": parseInt(this.office),
                                "emissionDate": numHoy,
                                "expirationDate": numVence,
                                "declareSii": 1,
                                //"priceListId": 18,
                                "client": pCliente,
                                "details": pDetalle,
                                "payments": pPago,
                                "references": pReferencia
                            }
                        } else { // boleta
                            emitDTE=
                            {
                                "documentTypeId": selectDTE,
                                "officeId": parseInt(this.office),
                                "emissionDate": numHoy,
                                "expirationDate": numHoy,
                                "declareSii": 1,
                                //"priceListId": 18,
                                "details": pDetalle
                                //"payments": pPago,
                            }
                        }
                        // consumir api Bsale para crear DTE
                        let resDTE =[];
                        //console.log(valToken);
                        try {
                            const response = await axios.post('https://api.bsale.cl/v1/documents.json', emitDTE , {headers : {"Accept":"application/json","content-type":"application/json","access_token":valToken}});
                            resDTE = response.data;
                        } catch (error) {
                            console.log (error);
                        }
                        if (resDTE.length!=0){
                            this.envioDTE(this.envio,resDTE.urlPdf,resDTE.urlXml);
                            this.html=resDTE.urlPdf;
                            this.btnPrt=true;
                            this.btnGrabar=false;
                            this.OutID=0;
                            this.OutID=resDTE.number;                    
                            const paramsDTE={
                                'contrato':this.contrato,
                                'numero':resDTE.number,
                                'tipoDte':selectDTE,
                                'tipoPago':selectPago,
                                'neto':this.neto,
                                'iva':this.iva,
                                'total':this.total,
                                'fecha':this.hoy,
                                'vencimiento':this.vencimiento,
                                'orden':this.orden,
                                'rutaPDF':resDTE.urlPdf,
                                'rutaXML':resDTE.urlXml,
                                'usuario':this.usu,
                                'sucursal':this.nSucursal,
                                'oficina':this.office,
                            };                    
                            await this.saveDTE(paramsDTE);
                        } else {
                            this.Msg='DTE no enviado'
                            this.msgbox=true;
                            this.color='red';
                            this.showSnack();
                        }
                        //console.log(res);
                    } else {
                        this.Msg='Seleccione DTE y Pago'
                        this.msgbox=true;
                        this.color='red';
                        this.showSnack();
                    }
                    this.loading=false;
                }
            } else {
                this.Msg='Venta Sin Sucursal'
                this.msgbox=true;
                this.color='red';
                this.showSnack();
            }
        },
        async saveDTE(parametrosDTE){
            const response = await axios.post(process.env.VUE_APP_URL + '/public/api/inv/v2/DTE/nueva',parametrosDTE);
            const datos=response.data;
            //console.log(parametrosDTE);
            if (datos=='si'){ 
                await this.updateReferencia();
            } else {
                this.Msg='DTE sin registro Local'
                this.msgbox=true;
                this.color='warning';
                this.showSnack();
            }
        },
        async updateReferencia(){
            var parametros0={
                'numero': this.OutID,
                'bodega':this.idLocal
            };
            const response0 = await axios.put(process.env.VUE_APP_URL + '/public/api/inv/referencia/actualiza/'+this.contrato+'/'+this.orden+'/'+this.entidad,parametros0);
            const datos0=response0.data;
            //console.log(datos0);
             if (datos0=='si'){
                await this.UpdateStock();
             } else {
                this.Msg='DTE enviado sin Referencia';
                this.msgbox=true;
                this.color='warning';
                this.showSnack();
             }
        },
        async UpdateStock(){
            let t=0;
            if (this.items.length!=0) {
                for (var i = 0; i < this.items.length; i++) {
                    var parametros1={
                            'contrato': this.contrato,
                            'sku': this.items[i].codigo,
                            'cantidad': this.items[i].cantidad,
                            'signo': '0-',
                            'bodega': this.items[i].bodega,
                            'usuario': this.usu,
                            'observa': '',
                            'origen':'Venta'};
                    const response1 = await axios.post(process.env.VUE_APP_URL + '/public/api/inv/stock',parametros1);
                    const datos1=response1.data;
                    if (datos1=='si'){ t++ }
                };
                if (t!=this.items.length) {
                    this.Msg='DTE enviado sin actualizar Stock';
                    this.msgbox=true;
                    this.color='warning';
                    this.showSnack();
                } else {
                    this.btnPrt=true;
                    this.Msg='DTE exitoso';
                    this.msgbox=true;
                    this.color='success';
                    this.showSnack();
                }
            }
        },
        async envioDTE(datoEnvio,datoPDF,datoXML){
            if (datoEnvio.trim()!=''){
                let InstFormData = new FormData();
                InstFormData.append('email' , datoEnvio);
                InstFormData.append('pdf' , datoPDF);
                InstFormData.append('xml' , datoXML);
                const response= await axios.post(process.env.VUE_APP_URL + '/public/api/server/sender', InstFormData , {headers : {'content-type': 'multipart/form-data'}});
                //console.log(response.data)
            }
        },
    }
}
</script>